import { COMPLIANCE_NAMES } from "@/constants/workers";

export const STAGE_NAMES = {
  OFFER: "Offer",
  COMPLIANCE: "Compliance",
  ONBOARDING: "Onboarding",
  INDUCTION: "Induction"
};

export const ONBOARDING_NAMES = {
  BANK: "Bank Details",
  CONTACTS: "Emergency Contacts"
};

export const FORM_NAMES = {
  BD: "bank_details",
  EC: "emergency_contacts",
  DBS: "dbs",
  REFERENCES: "references",
  RTW: "right_to_work",
  PID: "proof_of_id"
};

const { OFFER, COMPLIANCE, ONBOARDING, INDUCTION } = STAGE_NAMES;
const { PID, DBSC, RTW, POA, PRTW, PNIN, PDL, REFERENCES } = COMPLIANCE_NAMES;
const { BANK, CONTACTS } = ONBOARDING_NAMES;
const MOCKED_COMPLIANCES = [
  {
    name: PID,
    completed: false
  },
  {
    name: DBSC,
    completed: true
  },
  {
    name: RTW,
    completed: true
  },
  {
    name: POA,
    completed: true
  },
  {
    name: PRTW,
    completed: true
  },
  {
    name: PNIN,
    completed: true
  },
  {
    name: PDL,
    completed: true
  },
  {
    name: REFERENCES,
    completed: false
  }
];

const MOCKED_ONBOARDING = [
  {
    name: BANK,
    completed: false
  },
  {
    name: CONTACTS,
    completed: false
  }
];

const MOCKED_INDUCTIONS = [
  {
    document: {
      url:
        "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
      fileName: "Welcome to the Council.pdf"
    },
    imageUrl: "https://cdn.vuetifyjs.com/images/cards/halcyon.png"
  },
  {
    document: {
      url:
        "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
      fileName: "Welcome to the Council.pdf"
    },
    imageUrl: "https://cdn.vuetifyjs.com/images/cards/halcyon.png"
  },
  {
    document: {
      url:
        "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
      fileName: "Welcome to the Council.pdf"
    },
    imageUrl: "https://cdn.vuetifyjs.com/images/cards/halcyon.png"
  },
  {
    document: {
      url:
        "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
      fileName: "Welcome to the Council.pdf"
    },
    imageUrl: "https://cdn.vuetifyjs.com/images/cards/halcyon.png"
  }
];
export const MOCKED_SECTIONS = [
  {
    name: OFFER,
    completed: true,
    content: {
      salary: 2227500,
      startDate: "Friday 15th October, 2020",
      document: {
        url:
          "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf"
      }
    }
  },
  {
    name: COMPLIANCE,
    completed: false,
    content: MOCKED_COMPLIANCES
  },
  {
    name: ONBOARDING,
    completed: false,
    content: MOCKED_ONBOARDING
  },
  {
    name: INDUCTION,
    completed: false,
    content: MOCKED_INDUCTIONS
  }
];

export const PROOF_OF_IDS = {
  PASSPORT: "Passport",
  NIC: "National ID Card",
  CDL: "Current Driving License",
  FL: "Firearms License",
  ID: "Identity Card",
  BDDP: "Blue Disabled Drivers Pass",
  HMFIDC: "HM Forces ID Card",
  BRP: "Biometric Residence Permit"
};

export const PROOF_OF_ID_TYPES = [
  {
    title: PROOF_OF_IDS.PASSPORT,
    label: "Any current or valid passport",
    value: PROOF_OF_IDS.PASSPORT
  },
  {
    title: PROOF_OF_IDS.NIC,
    label: "Current and valid, for non-UK nationals",
    value: PROOF_OF_IDS.NIC
  },
  {
    title: PROOF_OF_IDS.CDL,
    label: "Full or provisional, UK, Isle of Man, Channel Islands or EU",
    value: PROOF_OF_IDS.CDL
  },
  {
    title: PROOF_OF_IDS.FL,
    label: "UK, Channel Islands and Isle of Man",
    value: PROOF_OF_IDS.FL
  },
  {
    title: PROOF_OF_IDS.ID,
    label: "Electoral Office of Northern Ireland",
    value: PROOF_OF_IDS.ID
  },
  {
    title: PROOF_OF_IDS.BDDP,
    label: "Current",
    value: PROOF_OF_IDS.BDDP
  },
  {
    title: PROOF_OF_IDS.HMFIDC,
    label: "UK",
    value: PROOF_OF_IDS.HMFIDC
  },
  {
    title: PROOF_OF_IDS.BRP,
    label: "UK only",
    value: PROOF_OF_IDS.BRP
  }
];

export const DBS_NAMES = {
  BASIC: "Basic",
  STANDARD: "Standard",
  ENHANCE: "Enhance",
  CHILD: "Child",
  EA: "Enhance Adult",
  ECA: "Enhance Child & Adult"
};

export const DBS_TYPES = [
  {
    label: DBS_NAMES.BASIC,
    value: DBS_NAMES.BASIC
  },
  {
    label: DBS_NAMES.STANDARD,
    value: DBS_NAMES.STANDARD
  },
  {
    label: DBS_NAMES.ENHANCE,
    value: DBS_NAMES.ENHANCE
  },
  {
    label: DBS_NAMES.CHILD,
    value: DBS_NAMES.CHILD
  },
  {
    label: DBS_NAMES.EA,
    value: DBS_NAMES.EA
  },
  {
    label: DBS_NAMES.ECA,
    value: DBS_NAMES.ECA
  }
];

export const RTW_NAMES = {
  BP: "British passport",
  EUP: "EU, EEA or Swiss passport",
  NP: "Named person in your parent or child’s passport",
  NIC: "National identity card",
  RC:
    "Registration Certificate or document certifying permanent residence from the Home Office",
  BRP: "Biometric residence permit ",
  CP: "Current passport endorsed to show you can indefinitely stay in the UK",
  CID: "Current immigration status document",
  CPWCE:
    "Current passport with with a current endoresement from the Home Office",
  COAHM: "Certificate of application issued by the Home Office",
  ARC: "Application registration card",
  NONE: "None of the above"
};

export const RTW_TYPES = [
  {
    label: RTW_NAMES.BP,
    value: RTW_NAMES.BP
  },
  {
    label: RTW_NAMES.EUP,
    value: RTW_NAMES.EUP
  },
  {
    label: RTW_NAMES.NP,
    value: RTW_NAMES.NP
  },
  {
    label: RTW_NAMES.NIC,
    value: RTW_NAMES.NIC
  },
  {
    label: RTW_NAMES.RC,
    value: RTW_NAMES.RC
  },
  {
    label: RTW_NAMES.BRP,
    value: RTW_NAMES.BRP
  },
  {
    label: RTW_NAMES.CP,
    value: RTW_NAMES.CP
  },
  {
    label: RTW_NAMES.CID,
    value: RTW_NAMES.CID
  },
  {
    label: RTW_NAMES.CPWCE,
    value: RTW_NAMES.CPWCE
  },
  {
    label: RTW_NAMES.COAHM,
    value: RTW_NAMES.COAHM
  },
  {
    label: RTW_NAMES.ARC,
    value: RTW_NAMES.ARC
  },
  {
    label: RTW_NAMES.NONE,
    value: RTW_NAMES.NONE
  }
];

export const REFERENCE_TYPES = [
  {
    label: "Professional",
    value: "Professional Reference"
  },
  {
    label: "Personal",
    value: "Personal Statement"
  }
];
